export const characterCardStyle = {
  cardStyle: {
    textAlign: 'center',
    overflow: 'hidden',
    ':hover': {
      boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, .1)',
      cursor: 'pointer',
    },
  },
  profilePhotoStyle: {
    borderRadius: '50%',
    width: 150,
    height: 150,
  },
  coreListStyle: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: '1rem',
    border: '1px solid #F5F5F5',
    borderRadius: 2,
  },
  virtualNameStyle: {
    margin: '.5rem 0 0 0',
    fontSize: '1.4rem',
    fontWeight: 'bold',
  },
  totalContributorsStyle: {
    width: '100%',
    borderRadius: 8,
    fontSize: '.8rem',
    background: '#F5F5F5',
    marginBottom: '.5rem',
    padding: '.3rem 0',
    display: {
      xs: 'none',
      md: 'inline-block',
    },
  },
  aprStyle: {
    lineHeight: 1,
    background: '#F9F9F9',
    color: '#000',
  },
  virtualTypeStyle: {
    color: '#43BDCE',
    fontWeight: 'bold',
    fontSize: '.9rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '.2rem',
    marginBottom: '1rem',
  },
};
